import { render, staticRenderFns } from "./UpdateUserAgreements.vue?vue&type=template&id=a2defbe4&"
import script from "./UpdateUserAgreements.vue?vue&type=script&lang=ts&"
export * from "./UpdateUserAgreements.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateUserAgreements.vue?vue&type=style&index=0&id=a2defbe4&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports